import { formatFileSize } from '@/utils/fileValidation'

export const MAX_EVENT_IMAGE_SIZE_BYTES = 5 * 1024 * 1024

export const ALLOWED_EVENT_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/svg+xml',
] as const

export const ALLOWED_EVENT_IMAGE_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.webp',
  '.svg',
] as const

export const SUPPORTED_IMAGE_FORMATS_LABEL = 'JPEG, PNG, WebP, SVG'

export const MAX_EVENT_IMAGE_SIZE_LABEL = `Maximum size: ${formatFileSize(MAX_EVENT_IMAGE_SIZE_BYTES)}`

export const MAX_EVENT_MEDIA_PER_EVENT = 10

export interface ValidateEventImageResult {
  valid: boolean
  error?: string
}

export function validateEventImageFile(file: File): ValidateEventImageResult {
  if (file.size > MAX_EVENT_IMAGE_SIZE_BYTES) {
    return {
      valid: false,
      error: `File must be under ${formatFileSize(MAX_EVENT_IMAGE_SIZE_BYTES)}.`,
    }
  }
  const ext = '.' + (file.name.split('.').pop() ?? '').toLowerCase()
  if (!(ALLOWED_EVENT_IMAGE_EXTENSIONS as readonly string[]).includes(ext)) {
    return {
      valid: false,
      error: `Format not allowed. Use ${SUPPORTED_IMAGE_FORMATS_LABEL}.`,
    }
  }
  const mime = (file.type || '').toLowerCase()
  if (
    mime &&
    !ALLOWED_EVENT_IMAGE_MIME_TYPES.includes(
      mime as (typeof ALLOWED_EVENT_IMAGE_MIME_TYPES)[number]
    )
  ) {
    return {
      valid: false,
      error: `Format not allowed. Use ${SUPPORTED_IMAGE_FORMATS_LABEL}.`,
    }
  }
  return { valid: true }
}
